export type ProfileModalResult = {
  success?: boolean;
  redirect?: boolean;
  redirectTo?: string;
};

export type ProfileModalHandle = {
  element: { modal: () => void };
  close: Promise<ProfileModalResult | undefined>;
};

export type OpenProfileModalPorts = {
  showModal: (options: {
    templateUrl: string;
    controller: string;
    controllerAs: string;
  }) => Promise<ProfileModalHandle>;
  onClose?: (result: ProfileModalResult | undefined) => void;
  logError?: (error: unknown) => void;
};

const PROFILE_MODAL = {
  templateUrl: 'dialogs/profile/profile.html',
  controller: 'ProfileController',
  controllerAs: 'vm',
} as const;

function followProfileClose(modal: ProfileModalHandle, ports: OpenProfileModalPorts): void {
  void modal.close
    .then((result) => {
      ports.onClose?.(result);
    })
    .catch((error: unknown) => {
      ports.logError?.(error);
    });
}

/**
 * Shared opener for the header and the e-agreements guard.
 * The Angular `#profile-modal` shell stays; React fills it.
 */
export async function openProfileModal(
  ports: OpenProfileModalPorts
): Promise<ProfileModalHandle | undefined> {
  try {
    const modal = await ports.showModal(PROFILE_MODAL);
    modal.element.modal();
    followProfileClose(modal, ports);
    return modal;
  } catch (error: unknown) {
    ports.logError?.(error);
    return undefined;
  }
}
